
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_21553_98431)"}},[_c('path',{attrs:{"d":"M18.813 7.393a.64.64 0 000-.906l-.961-.962a.64.64 0 00-.813-.076l-2.022 1.373 1.366-2.035a.64.64 0 00-.08-.81l-2.085-2.085a.64.64 0 00-.73-.124l-.361.173.173-.383a.64.64 0 00-.131-.716l-.655-.654a.64.64 0 00-.906 0L6.523 5.272l7.206 7.205 5.084-5.084zM5.576 6.219L4.104 7.69a.64.64 0 000 .906L5.5 9.993c.27.269.4.64.358 1.018-.041.378-.25.713-.57.917C1.184 14.544.801 14.926.675 15.052a2.316 2.316 0 000 3.271c.903.903 2.37.901 3.272 0 .126-.125.508-.508 3.123-4.61.205-.321.539-.529.917-.57.38-.042.75.088 1.019.356l1.396 1.397c.25.25.656.25.906 0l1.472-1.472-7.205-7.205zm-2.584 11.07a.905.905 0 11-1.28-1.281.905.905 0 011.28 1.28z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_21553_98431"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    